"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("@/app/shared/context");
const Router_1 = require("@/app/shared/router/Router");
const rootStore_1 = require("@/app/shared/store/rootStore");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const App = () => {
    return ((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(context_1.InterfaceContextProvider, { styleContainer: document.head, children: (0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: rootStore_1.store, children: (0, jsx_runtime_1.jsx)(context_1.SessionProvider, { children: (0, jsx_runtime_1.jsx)(Router_1.Router, {}) }) }) }) }) }));
};
exports.App = App;
exports.default = exports.App;
